import React from 'react';
import { Link } from 'react-router-dom';
import Fari from "../assets/Fariha.jpg";
import "../styles/Developers.css";

export const Fariha = () => {
    return(
        <div className="developer-profile-container">
            <h1 className="developer-header">About Fariha Farhin</h1>
             <img src={Fari} alt="Fariha's Portrait" className="developer-image" />
            <p className="developer-bio">
                As of writing this she is a third year computer science student. She is an aspiring 
                frontend developer and graphic designer. Growing up, she always had an intense 
                fascination with the internet and the unique design style it created. One of her 
                biggest passions is to connect her graphic design skills with her frontend programming skills.
            </p>
            <Link to="/about" className="back-button">Back to Developers</Link>
        </div>
    );
};
